import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';

import MathContent from '../../math-content';
import ValidatedTextarea from '../../textarea/components/validated';

const Container = styled.div`
    margin: 0 0 0 32px;

    @media (max-width: 767px) {
        margin: 0 0 0 26px;
    }
`;

export const Header = styled.div``;

const TextareaContainer = styled.div`
    padding: 24px 0 32px 0;
`;

const FeedbackContainer = styled.div``;

export const Label = styled.span`
    display: inline-block;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 24px;
`;

export const Feedback = styled.span`
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0;
    margin-top: 8px;
    line-height: 24px;
`;

export const Suggestion = styled.div`
    display: flex;
    flex-direction: column;
`;

const getFeedback = (answer) => {
    const [myAnswer] = answer;
    if (myAnswer && myAnswer.trim()) {
        return (
            <>
                <div>{`Gli esercizi a risposta aperta non vengono corretti in modo automatico e non è possibile mostrarti il risultato.`}</div>
                <div>{`Per sapere se la tua risposta è esatta parla con l'insegnante.`}</div>
            </>
        );
    }

    return "Non hai risposto a questa domanda. Chiedi all'insegnante la risposta esatta.";
};

const OpenAnswerCorrection = ({ exercise, answers = {}, solution }) => {
    const { answer = [] } = answers;

    return (
        <Container>
            <Header>
                {exercise.prompt && <MathContent>{exercise.prompt}</MathContent>}
                {exercise.question && <MathContent>{exercise.question}</MathContent>}
            </Header>

            {solution ? (
                <>
                    <TextareaContainer>
                        <ValidatedTextarea
                            disabled={true}
                            type={exercise.correctAnswer ? 'success' : 'missing'}
                            value={exercise.correctAnswer && exercise.correctAnswer.toString()}
                        />
                    </TextareaContainer>
                    <Label>
                        <>
                            <div>{`Gli esercizi a risposta aperta non vengono corretti in modo automatico e non è possibile mostrarti il risultato.`}</div>
                            <div>{`Per sapere se la tua risposta è esatta parla con l'insegnante.`}</div>
                        </>
                    </Label>
                </>
            ) : (
                <>
                    <TextareaContainer>
                        <ValidatedTextarea disabled={true} type={answer.length === 1 ? 'warning' : 'missing'} value={answer.toString()} />
                    </TextareaContainer>
                    <FeedbackContainer>
                        <Label>{getFeedback(answer)}</Label>
                        {exercise.correctAnswer && (
                            <Suggestion>
                                <Label>{'Un esempio di risposta esatta:'}</Label>
                                <Feedback>
                                    <MathContent>{exercise.correctAnswer}</MathContent>
                                </Feedback>
                            </Suggestion>
                        )}
                    </FeedbackContainer>
                </>
            )}
        </Container>
    );
};

OpenAnswerCorrection.propTypes = {
    answers: PropTypes.shape({
        exerciseId: PropTypes.number,
        answer: PropTypes.array,
    }),
    exercise: PropTypes.object,
    solution: PropTypes.bool,
};

export default OpenAnswerCorrection;
